export const PARCEL_STATUS_IDS = [
  'pending',
  'arrived',
  'collected',
  'returned',
  'archived',
];

export function resolveParcelStatus(parcel) {
  if (parcel?.archived_at) return 'archived';
  const raw = String(parcel?.status ?? 'pending').toLowerCase();
  return PARCEL_STATUS_IDS.includes(raw) ? raw : 'pending';
}

export function getParcelStatusSortRank(parcelOrStatus) {
  const resolved = typeof parcelOrStatus === 'object'
    ? resolveParcelStatus(parcelOrStatus)
    : resolveParcelStatus({ status: parcelOrStatus });
  const idx = PARCEL_STATUS_IDS.indexOf(resolved);
  return idx === -1 ? PARCEL_STATUS_IDS.length : idx;
}

/** Workflow status order; then most recently updated. */
export function compareParcelListItems(a, b) {
  const sr = getParcelStatusSortRank(a) - getParcelStatusSortRank(b);
  if (sr !== 0) return sr;

  const ta = new Date(a.updated_at ?? a.created_at ?? 0).getTime();
  const tb = new Date(b.updated_at ?? b.created_at ?? 0).getTime();
  return tb - ta;
}
